/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * Timefill API
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';

/**
 * メールアドレスとパスワードでログインし、認証トークンを発行します。
 * @summary ログイン（サインイン）
 */
export const signInBody = zod.object({
  "email": zod.string().email().describe('ユーザーのメールアドレス'),
  "password": zod.string().describe('パスワード')
})

export const signInResponse = zod.object({
  "data": zod.object({
  "email": zod.string(),
  "provider": zod.string(),
  "uid": zod.string(),
  "id": zod.number(),
  "allow_password_change": zod.boolean()
})
})


/**
 * 現在のアクセストークンが有効かどうかを検証します。
 * @summary トークン検証（有効性チェック）
 */
export const validateTokenHeader = zod.object({
  "access-token": zod.string().optional().describe('アクセストークン'),
  "client": zod.string().optional().describe('クライアント識別子'),
  "uid": zod.string().optional().describe('ユーザーID（メールアドレス）')
})


/**
 * 現在の認証トークンを無効化し、サインアウトします。
 * @summary ログアウト（サインアウト）
 */
export const signOutHeader = zod.object({
  "access-token": zod.string().optional().describe('アクセストークン'),
  "client": zod.string().optional().describe('クライアント識別子'),
  "uid": zod.string().optional().describe('ユーザーID（メールアドレス）')
})


/**
 * メールアドレスとパスワードで新規ユーザーを作成します。
 * @summary ユーザー登録（サインアップ）
 */
export const signUpBody = zod.object({
  "email": zod.string().email().describe('メールアドレス'),
  "password": zod.string().describe('パスワード'),
  "password_confirmation": zod.string().describe('パスワード（確認）')
})

export const signUpResponse = zod.object({
  "status": zod.string(),
  "data": zod.object({
  "id": zod.number(),
  "provider": zod.string(),
  "uid": zod.string(),
  "allow_password_change": zod.boolean(),
  "email": zod.string(),
  "created_at": zod.string().datetime({}),
  "updated_at": zod.string().datetime({})
})
})


/**
 * ログイン中ユーザーのアカウント情報（メール/パスワード）を更新します。パスワード変更時は current_password が必須です。
 * @summary アカウント更新
 */
export const updateAccountHeader = zod.object({
  "access-token": zod.string().optional().describe('アクセストークン'),
  "client": zod.string().optional().describe('クライアント識別子'),
  "uid": zod.string().optional().describe('ユーザーID（メールアドレス）')
})

export const updateAccountBody = zod.union([zod.object({
  "email": zod.string().email().optional().describe('新しいメールアドレス')
}),zod.object({
  "current_password": zod.string().describe('現在のパスワード（ログイン中の変更に使用）'),
  "password": zod.string().describe('新しいパスワード'),
  "password_confirmation": zod.string().describe('新しいパスワード（確認）')
})])


/**
 * ログイン中ユーザーのアカウントを削除します。
 * @summary アカウント削除（退会）
 */
export const destroyAccountHeader = zod.object({
  "access-token": zod.string().optional().describe('アクセストークン'),
  "client": zod.string().optional().describe('クライアント識別子'),
  "uid": zod.string().optional().describe('ユーザーID（メールアドレス）')
})


/**
 * パスワード再設定メールを送信します。redirect_url が必要です。
 * @summary パスワードリセット要求
 */
export const passwordResetRequestBody = zod.object({
  "email": zod.string().email().describe('登録メールアドレス'),
  "redirect_url": zod.string().url().describe('再設定完了後に遷移するURL')
})


/**
 * リセットトークン（reset_password_token）でパスワードを再設定します。認証ヘッダは不要です。
 * @summary パスワード再設定（トークン）
 */
export const resetPasswordBody = zod.object({
  "reset_password_token": zod.string().describe('リセットトークン（メールで配布）'),
  "password": zod.string().describe('新しいパスワード'),
  "password_confirmation": zod.string().describe('新しいパスワード（確認）')
})


/**
 * 現在のアプリケーションのバージョンを返します。
 * @summary バージョン情報の取得
 */
export const getVersionResponse = zod.object({
  "version": zod.string()
})
